export default "__VITE_ASSET__VO0j8_Rk__"